/**
 * Bootstraps every `[anudan_donation_form]` and `[anudan_donate_button]` on the page
 * (WP-18, `08-PHASE-3-BUILD.md`).
 *
 * `window.AnudanEngine` is the one global this bundle is allowed to touch
 * (`07-CODE-STANDARDS.md` §7.1). `Frontend\CheckoutAssets` prints the configuration as a
 * `<script type="application/json">` block before this file (0.9.37: data, not a script, so an
 * enforced Content Security Policy needs no inline-script allowance); it is read onto
 * `window.AnudanEngine.config` here, before anything else runs. Nothing here creates a second global.
 */

import { Wizard } from './checkout/wizard.js';
import { startTablet } from './checkout/tablet.js';
import { readConfig } from './shared/config-block.js';

readConfig( 'anudan-checkout' );

function boot() {
	// 0.9.0 tablet mode: one root per tablet page.
	const tablet = document.querySelector( '[data-anudan-tablet]' );

	if ( tablet ) {
		startTablet( tablet );
	}

	document.querySelectorAll( '[data-anudan-checkout][data-anudan-mode="page"]' ).forEach( ( container ) => {
		new Wizard( container ).init();
	} );

	document.querySelectorAll( '[data-anudan-checkout-trigger]' ).forEach( ( trigger ) => {
		const fundId = trigger.getAttribute( 'data-anudan-fund-id' );
		const modal = document.querySelector(
			`[data-anudan-checkout][data-anudan-mode="modal"][data-anudan-fund-id="${ fundId }"]`
		);

		if ( ! modal ) {
			return;
		}

		const backdrop = document.createElement( 'div' );

		backdrop.className = 'anudan-checkout__backdrop';
		backdrop.hidden = true;
		backdrop.addEventListener( 'click', () => wizard.close() );

		/*
		 * Moved to a direct child of <body>, not left where `button.php` placed it. `position:
		 * fixed` only escapes the page's own layout when nothing between the element and the
		 * viewport creates a new containing block — and a `transform`, `filter` or `perspective`
		 * on any ancestor (a block theme's own animation wrapper is a common, entirely ordinary
		 * source of exactly one of those) traps a fixed-position descendant inside it instead.
		 * `docs/build-log/WP-18-checkout-ui-standard-lane.md` records finding this against the
		 * bundled Twenty Twenty-Five theme, not a deliberately hostile one — the same shape ADR
		 * 0004's amendment already names for `!important`: an entirely ordinary theme rule, not a
		 * hostile one, was the thing this needed to survive.
		 */
		document.body.appendChild( backdrop );
		document.body.appendChild( modal );

		const wizard = new Wizard( modal );

		wizard.backdrop = backdrop;

		let initialised = false;

		trigger.addEventListener( 'click', async () => {
			if ( ! initialised ) {
				initialised = true;
				await wizard.init();
			}

			wizard.open( trigger );
		} );
	} );
}

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
